export default __webpack_public_path__ + "static/media/SAKET CHIRANIA.ad529c8d.png";